import type { IconProps } from "@/types/IconProps";

export function Phone(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12 6.201 22.5 12 22.5V24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12v-1.5c5.799 0 10.5-4.701 10.5-10.5"></path>
      <path d="M12.508 15.012a.55.55 0 0 0 .667-.166l.195-.256a1.1 1.1 0 0 1 .88-.44h1.65a1.1 1.1 0 0 1 1.1 1.1v1.65a1.1 1.1 0 0 1-1.1 1.1A9.9 9.9 0 0 1 6 8.1 1.1 1.1 0 0 1 7.1 7h1.65a1.1 1.1 0 0 1 1.1 1.1v1.65a1.1 1.1 0 0 1-.44.88l-.257.193a.55.55 0 0 0-.161.678 7.7 7.7 0 0 0 3.516 3.511"></path>
    </svg>
  );
}
